module.exports = __webpack_public_path__ + "static/img/six_icon.64b99fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/six_icon.png
// module id = cDDf
// module chunks = 12